module.exports = __webpack_public_path__ + "img/equity.8ae4af24.svg";